

























































































































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import PanVerticalIcon from 'vue-material-design-icons/SwapVertical.vue';
import draggable from 'vuedraggable';
import _ from 'lodash';
import { moveItem } from '@/dex-shared/lib/ArrayHelper';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Content from '@/dex-shared/components/content/Content.vue';
import UEEPegasusPangareRequestService from '@/helpers/pegasus-pangare/request';

const weeklyAssessmentIdentifier = '[MATEMATICA|NATUREZA|HUMANAS|LINGUAGENS]';

export default Vue.extend({
  components: {
    Content,
    pxButton,
    pxCard,
    Datetime,
    SquareEditOutlineIcon,
    TrashCanOutlineIcon,
    PanVerticalIcon,
    draggable,
  },

  props: {
    selectedQuestions: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      creating: true,
      questionTag: '',
      searchedByTag: false,
      updatable: false,
      pushingExam: false,
      pullingQuestions: false,
      addQuestionsFromListId: '',
      addingQuestionsFromList: false,
    };
  },

  computed: {
    ...mapGetters({
      exam: 'currentExam',
    }),
    questions: {
      get() {
        return this.$store.state.exams.questions;
      },
      set(newValue: Array<any>) {
        this.$store.state.exams.questions.splice(0);
        this.$store.state.exams.questions.push(...newValue);
      },
    },
    hasSelectedQuestions(): Boolean {
      return this.selectedQuestions.length > 0;
    },
  },

  async created() {
    this.creating =
      this.$route.name === 'exam_create' ||
      (this.selectedQuestions && this.selectedQuestions.length > 0);

    if (this.creating) {
      this.$store.commit('SET_EMPTY_EXAM');
      if (this.selectedQuestions && this.selectedQuestions.length > 0) {
        this.$store.commit('SET_EXAM_QUESTIONS', this.selectedQuestions);
      }
    } else {
      let examId = parseInt(this.$route.params.examId);
      await this.$store.dispatch('PULL_EXAM', examId);
      this.$store.commit(
        'SET_EXAM_QUESTIONS',
        this.$store.getters.currentExam.questions,
      );
      //TODO no exam found
    }
  },

  methods: {
    pushExam: async function() {
      //TODO valid exam
      if (this.pushingExam === false) {
        const examGroups = this.exam.examGroups || [];
        const isUeeWeeklyAssessment = this.exam.isUeeWeeklyAssessment || false;

        this.exam.questions = this.questions;
        this.pushingExam = true;
        await this.$store.dispatch('PUSH_EXAM', this.exam);

        if (examGroups.length > 0) {
          if (
            this.exam.description &&
            this.exam.description
              .toUpperCase()
              .includes(weeklyAssessmentIdentifier)
          ) {
            const result = await UEEPegasusPangareRequestService.upsertPracticeExamCalendarEvents(
              {
                practiceExam: {
                  id: this.exam.id,
                  name: this.exam.name,
                  slug: this.exam.slug,
                  description: this.exam.description,
                  startMomentIsoString: this.exam.start,
                },
                dexExamGroups: examGroups.map(examGroup => examGroup.slug),
              },
            );

            if (result.identifier !== 'CalendarEventUpserted') {
              alert('Erro ao atualizar ou criar o evento na agenda de UEE.');
            }
          } else if (isUeeWeeklyAssessment) {
            const result = await UEEPegasusPangareRequestService.deletePracticeExamCalendarEvents(
              {
                practiceExamId: this.exam.id,
                practiceExamStartDate: this.exam.start,
                dexExamGroups: examGroups.map(examGroup => examGroup.slug),
              },
            );

            if (result.identifier !== 'CalendarEventDeleted') {
              alert('Erro ao atualizar ou criar o evento na agenda de UEE.');
            }
          }
        }

        this.pushingExam = false;
        //TODO error inputing exam
        if (this.exam.id) {
          if (this.creating) {
            this.$router.push(`/prova/${this.exam.id}`);
          } else {
            this.$router.go(-1);
            this.$router.push(`/prova/${this.exam.id}`);
          }
        }
      }
    },
    removeItem(index: number) {
      this.questions.splice(index, 1);
    },
    moveItem(from: number, to: number) {
      this.questions = moveItem(this.questions, from, to);
    },
    goToExam() {
      this.$router.push('/');
    },
    async pullQuestionsByTag() {
      this.pullingQuestions = true;
      await this.$store.dispatch('PULL_QUESTIONS_BY_TAGS', this.questionTag);
      this.pullingQuestions = false;
      if (this.questions.length > 0) {
        this.searchedByTag = true;
      } else {
        this.searchedByTag = false;
      }
      this.updatable = false;
    },
    shuffleQuestions() {
      this.questions = _.shuffle(this.questions);
    },
    openQuestion(questionId: number) {
      this.updatable = true;
      let route = this.$router.resolve({
        path: `/editar_questao/${questionId}`,
      });
      window.open(route.href, '_blank');
    },
    changeStrategy() {
      this.exam.scoringWeights =
        this.exam.scoringStrategy === 'discounted_count'
          ? {
              weights: {},
              rules: {
                correct: 1,
                wrong: 0,
              },
            }
          : { weights: {}, rules: {} };
      this.$forceUpdate();
    },
    async addQuestionsFromList() {
      if (
        this.addQuestionsFromListId &&
        !isNaN(parseInt(this.addQuestionsFromListId))
      ) {
        this.addingQuestionsFromList = true;
        await this.$store.dispatch(
          'ADD_QUESTIONS_BY_LIST_ID',
          parseInt(this.addQuestionsFromListId),
        );
        this.addingQuestionsFromList = false;
      }
    },
  },
});
